export const setting = { // 状态 1-未解决 2-解决中 3-已解决 4-已在线解决 5-已转单
  workOrderStatus: [{
    value: '1', label: '未解决'
  }, {
    value: '2', label: '解决中'
  }, {
    value: '3', label: '已解决'
  }, {
    value: '4', label: '已在线解决'
  }, {
    value: '5', label: '已转单'
  }]
}

export default {
  setting
}



// WEBPACK FOOTER //
// ./src/data/setting.js